// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hJxVO","question":"styles_question__2u_En","description":"styles_description__2esqW"};